export default {
   props: {
      pErrorList: {
         type: Object,
         default: function () {
            return {}
         }
      }
   },
   methods: {
      vForIdKey: function (idObj) {
         return !$.isEmptyObject(idObj) && 'id' in idObj ? idObj.id : -Math.random();
      },

      hasFieldErrors: function (name) {
         if(name in this.pErrorList)
         {
            return !$.isEmptyObject(this.pErrorList[name]);
         }
      },
      hasErrors: function (prefix) {
         return Object.keys(this.pErrorList)
                 .reduce((accumulator, error) => accumulator || error.startsWith(prefix), false);
      },
      getFieldErrors: function (name) {
         if(name in this.pErrorList)
         {
            return this.pErrorList[name];
         }
         return [];
      },
      getErrors: function (prefix) {
         return Object.entries(this.pErrorList)
                 .filter(entry => entry[0].startsWith(prefix))
                 .flatMap(entry => entry[1]);
      },
   },
   computed: {
      nbOfErrors: function () {
         return Object.keys(this.pErrorList).length;
      },
   }
}